interface LessonClosedCaptionsProps {
  text: string | null;
}

/**
 * Lesson video closed captions overlay.
 *
 * Separate from the simulator `InstructorVoiceCaption` strip — same visual
 * language (translucent dark, rounded, subtle border), different trigger:
 * this renders only the cue text passed in for the currently-playing video.
 */
export default function LessonClosedCaptions({ text }: LessonClosedCaptionsProps) {
  if (!text) return null;
  return (
    <div
      className="pointer-events-none absolute inset-x-0 bottom-3 sm:bottom-4 flex justify-center px-4"
      aria-live="polite"
      aria-atomic="true"
    >
      <p className="max-w-[92%] rounded-xl border border-white/15 bg-black/70 backdrop-blur-sm px-4 py-2 text-center text-sm sm:text-base leading-snug text-white shadow-[0_0_20px_rgba(0,0,0,0.45)]">
        {text}
      </p>
    </div>
  );
}
